/**
 *
 */


import React, { Fragment, PureComponent } from 'react';
import { Row, Col } from 'antd';
import StyledLanding from '../../../components/StyledLanding';
import endPoints from '../../../config/endPoints';
import { ABOUTUS_CONSTANTS, GetCityLocation } from '../constants';
import { SubTitle, Container } from '../../../components';

class AboutsMap extends PureComponent { // eslint-disable-line react/prefer-stateless-function
  constructor(props) {
    super(props);
    this.state = {
      location: '',
    };
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(getlocation) {
    this.setState({ location: getlocation });
  }

  render() {
    const { ZAGGLE_MAP } = ABOUTUS_CONSTANTS;
    const { location } = this.state;
    return (
      <StyledLanding className="padding-tb-8">
        <Container>
          <Row align="stretch" type="flex" gutter={16}>
            <Col xs={24} sm={24} md={12} lg={12} xl={12} style={{ position: 'relative' }}>
              <div className="office">
                <SubTitle fontWeight="900" className="margin-b-2">Looking to visit our Office?</SubTitle>
                <strong className="font-16">Corporate Office:</strong>
                <p>
                  Boomerang Building,<br />
                  Ground Floor, B-1004,<br />
                  Yadav Nagar, Chandivali. Powai,<br />
                  Mumbai- 400072<br />
                  Ph: <b> 022 4879 4879 </b>
                </p>
              </div>
              <div className="office">
                <strong className="font-16">Registered office</strong>
                <p>
                  15th Floor – Western Block,<br />Vamasiram – Suvarna Durga Tech Park,<br />
                  Nanakramguda Village, Serilingampally Mandal,<br /> GHMC Serilingampally Circle, Ranga Reddy District, 500032, Telangana.<br />
                  CIN-L65999TG2011PLC074795 | All rights reserved.<br />
                  Ph: <b> 040 2311 9049 </b>
                </p>
              </div>
              {location ?
                <div className="location" id="Gurgaon">
                  <b>{location} Office:</b>
                  <p>
                    {GetCityLocation(location).address}<br />
                    Ph: <b>{GetCityLocation(location).phone}</b>
                  </p>
                  {GetCityLocation(location).addressTwo ?
                    <Fragment>
                      <p>
                        {GetCityLocation(location).addressTwo}<br />
                      </p>
                    </Fragment> : ''}
                </div> : ''}
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <div className="india-map">
                {ZAGGLE_MAP.map((item) => (
                  <div className={item.className} data-name={item.alt} key={item.keyIndex}>
                    <span onClick={() => this.handleClick(item.alt)} role="presentation">{item.alt}</span>
                    <img src={item.image} alt={item.alt} className="pointer" />
                  </div>
                ))}
                <img src={endPoints.ABOUTUS_INDIA_MAP.URL} alt={endPoints.ABOUTUS_INDIA_MAP.ALT} className="map-img" />
              </div>
            </Col>
          </Row>
        </Container>
      </StyledLanding>
    );
  }
}

export default AboutsMap;



// WEBPACK FOOTER //
// client/containers/StaticPages/ContactUS/Map.js